// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"styles_menuPaper__3UfSa","menuList":"styles_menuList__1Iz7x"};